import React, { useState } from 'react';
import { FolderOpen, Package, User, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../components/AuthProvider';
import ServiceProjectsTab from '../components/ServiceProjectsTab';
import SubmittedProjectsTab from '../components/SubmittedProjectsTab';

const ProjectsPage: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'services' | 'submitted'>('services');

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Bouton retour */}
        <div className="mb-6">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors shadow-sm"
          >
            <ArrowLeft className="w-5 h-5 text-gray-700" />
            <span className="text-gray-700 font-medium">Retour</span>
          </button>
        </div>

        {/* En-tête */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-4">
            <FolderOpen className="w-8 h-8 text-blue-600" />
            <h1 className="text-3xl font-bold text-gray-900">
              {user?.isAdmin ? 'Tous les projets' : 'Mes projets'}
            </h1>
          </div>
          <p className="text-gray-600">
            {user?.isAdmin 
              ? 'Vue d\'ensemble de tous les projets avec leurs étapes de conception'
              : 'Suivez l\'avancement de vos projets en temps réel'
            }
          </p>
        </div>

        {/* Onglets */}
        <div className="mb-8">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8">
              <button
                onClick={() => setActiveTab('services')}
                className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors ${
                  activeTab === 'services'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center space-x-2">
                  <Package className="w-4 h-4" />
                  <span>Projets Services/Packs</span>
                </div>
              </button>
              <button
                onClick={() => setActiveTab('submitted')}
                className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors ${
                  activeTab === 'submitted'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center space-x-2">
                  <User className="w-4 h-4" />
                  <span>Projets Personnels</span>
                </div>
              </button>
            </nav>
          </div>
        </div>

        {/* Contenu selon l'onglet actif */}
        {activeTab === 'services' ? (
          <ServiceProjectsTab isAdmin={user?.isAdmin} />
        ) : (
          <SubmittedProjectsTab isAdmin={user?.isAdmin} />
        )}
      </div>
    </div>
  );
};

export default ProjectsPage;
